import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/images/logo.png'; // Changed to PNG import
import { FaBars, FaShoppingBag, FaGoogle } from 'react-icons/fa';
import { loginAdmin, loginWithGoogle } from '../utils/adminAuth';
import './CustomAppBar.css';

const CustomAppBar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const [showAdminDialog, setShowAdminDialog] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  const handleAdminAccess = async () => {
    if (!adminEmail.trim() || !adminPassword.trim()) {
      alert('الرجاء إدخال الإيميل وكلمة المرور');
      return;
    }

    setIsVerifying(true);
    try {
      const isValid = await loginAdmin(adminEmail, adminPassword);
      if (isValid) {
        sessionStorage.setItem('adminAuthenticated', 'true');
        navigate('/AdminHomeScreen');
        setShowAdminDialog(false);
        setAdminEmail('');
        setAdminPassword('');
      } else {
        alert('بيانات الدخول غير صحيحة');
      }
    } catch (error) {
      console.error('Error verifying admin password:', error);
      alert('حدث خطأ أثناء التحقق من كود الإدارة. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsVerifying(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsVerifying(true);
    try {
      await loginWithGoogle();
      // The page will redirect to Google
    } catch (error) {
      console.error('Error logging in with Google:', error);
      alert('حدث خطأ أثناء الدخول عبر جوجل');
      setIsVerifying(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdminAccess();
    }
  };

  return (
    <>
      {/* Enhanced App Bar */}
      <div className="appbar-container">
        {/* Gradient overlay for depth */}
        <div className="appbar-gradient-overlay"></div>
        
        {/* Left Side: Enhanced Drawer Icon */}
        <button
          className="appbar-icon-button menu-button"
          onClick={onMenuClick}
          title="القائمة"
          aria-label="فتح القائمة"
        >
          <FaBars className="icon" />
          <div className="button-ripple"></div>
        </button>

        {/* Center: Enhanced Title and Logo */}
        <div className="appbar-center">
          <div 
            className="logo-container"
            onClick={() => setShowAdminDialog(true)}
            style={{ cursor: 'default' }}
          >
            <img
              src={logoImage}
              alt="Clickfish DZ Logo"
              className="appbar-logo" 
              style={{
                width: '45px',
                height: '45px',
                objectFit: 'contain'
              }}
            />
            <div className="logo-glow"></div>
          </div>
          <div className="title-container">
            <h1 className="appbar-title">
              <span className="title-gradient">Clickfish</span>
              <span className="title-accent">DZ</span>
            </h1>
            <div className="title-underline"></div>
          </div>
        </div>

        {/* Right Side: Enhanced Orders Button */}
        <button
          className="appbar-icon-button orders-button"
          onClick={() => navigate('/OrdersPage')}
          title="الطلبات"
          aria-label="عرض الطلبات"
        >
          <FaShoppingBag className="icon" />
          <div className="button-ripple"></div>
          <div className="orders-badge">
            <span className="orders-dot"></span>
          </div>
        </button>
      </div>

      {/* Enhanced Admin Access Dialog */}
      {showAdminDialog && (
        <div className="admin-dialog-overlay">
          <div className="admin-dialog-box">
            <div className="admin-dialog-header">
              <div className="admin-icon">🔐</div>
              <h2 className="admin-title">دخول الإدارة</h2>
              <p className="admin-subtitle">أدخل كود الوصول للإدارة</p>
            </div>
            
            <div className="admin-input-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <input
                type="email"
                placeholder="البريد الإلكتروني"
                value={adminEmail}
                onChange={(e) => setAdminEmail(e.target.value)}
                className="admin-input"
                autoFocus
              />
              <div className="input-focus-line"></div>
              
              <input
                type="password"
                placeholder="كلمة المرور"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                className="admin-input"
              />
              <div className="input-focus-line"></div>
            </div>
            
            <div className="admin-dialog-actions" style={{ flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                <button
                  className="admin-button cancel"
                  onClick={() => {
                    setShowAdminDialog(false);
                    setAdminEmail('');
                    setAdminPassword('');
                  }}
                  style={{ flex: 1 }}
                >
                  إلغاء
                </button>
                <button
                  className="admin-button submit"
                  onClick={handleAdminAccess}
                  disabled={isVerifying}
                  style={{ opacity: isVerifying ? 0.7 : 1, cursor: isVerifying ? 'wait' : 'pointer', flex: 2 }}
                >
                  {isVerifying ? 'جاري التحقق...' : 'دخول'}
                </button>
              </div>

              <button
                className="admin-button google"
                onClick={handleGoogleLogin}
                disabled={isVerifying}
                style={{
                  width: '100%',
                  background: 'white',
                  color: '#4285F4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  border: '1px solid #4285F4',
                  padding: '12px',
                  borderRadius: '12px',
                  fontWeight: '600',
                  opacity: isVerifying ? 0.7 : 1,
                  cursor: isVerifying ? 'wait' : 'pointer'
                }}
              >
                <FaGoogle /> دخول عبر جوجل
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomAppBar;